/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useStyles } from 'bold-ui'
import { blue, green, red, yellow } from 'bold-ui/lib/styles/colors'
import { RadioFieldContainer } from 'components/form/field/RadioFieldContainer'
import { ClassificacaoRiscoEncaminhamentoEnum } from 'graphql/types.generated'
import { CSSProperties } from 'react'
import { MetaPath } from 'util/metaPath'

export interface ClassificacaoRiscoEncaminhamentoButtonsProps {
  name: MetaPath<ClassificacaoRiscoEncaminhamentoEnum>
  value: ClassificacaoRiscoEncaminhamentoEnum
}

interface classificacaoButtonContent {
  fieldColorHover: string
  fieldColor: string
  borderColor: string
  fontColor: string
  descricao: string
}

const classificacaoRiscoColors: Record<ClassificacaoRiscoEncaminhamentoEnum, classificacaoButtonContent> = {
  EMERGENCIA: {
    fieldColorHover: red.c80,
    fieldColor: red.c90,
    borderColor: red.c60,
    fontColor: red.c40,
    descricao: 'Emergência',
  },
  URGENCIA: {
    fieldColorHover: yellow.c80,
    fieldColor: yellow.c90,
    borderColor: yellow.c60,
    fontColor: yellow.c40,
    descricao: 'Urgência',
  },
  PRIORITARIO: {
    fieldColorHover: green.c80,
    fieldColor: green.c90,
    borderColor: green.c60,
    fontColor: green.c40,
    descricao: 'Prioritário',
  },
  ELETIVO: {
    fieldColorHover: blue.c80,
    fieldColor: blue.c90,
    borderColor: blue.c60,
    fontColor: blue.c40,
    descricao: 'Eletivo',
  },
}

export function ClassificacaoRiscoEncaminhamentoButton(props: ClassificacaoRiscoEncaminhamentoButtonsProps) {
  const { name, value } = props

  const { fieldColorHover, fieldColor, borderColor, fontColor, descricao } = classificacaoRiscoColors[value]

  const { classes } = useStyles(() => createStyles(fontColor, borderColor, fieldColor, fieldColorHover), [])

  return <RadioFieldContainer name={name} value={value} style={classes.card} label={descricao} />
}

const createStyles = (fontColor: string, borderColor: string, fieldColor: string, fieldColorHover: string) => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    width: '9.5rem',
    height: '4rem',
    boxShadow: '0px 2px 1px rgba(0, 0, 0, 0.04), 0px 1px 5px rgba(0, 0, 0, 0.12)',
    fontWeight: 'bold',
    borderRadius: '2px',
    border: '1px solid' + borderColor,
    backgroundColor: fieldColor,
    color: fontColor,
    '&:focus': {
      boxShadow: '0px 2px 1px rgba(0, 0, 0, 0.04), 0px 1px 5px rgba(0, 0, 0, 0.12)',
    },
    '&:hover': {
      backgroundColor: fieldColorHover,
    },
  } as CSSProperties,
})
